export default __webpack_public_path__ + "static/media/popup_create.6207f85a.png";